<!-- Trigger Button -->
@if (visible) {
  <div class="trigger-button" (click)="loadCommitMessages()">
    <span>Commits</span>
    <div class="badge-close">
      <a (click)="close()"><fa-icon [icon]="['fas', 'close']"></fa-icon></a>
    </div>
  </div>
}

<!-- Modal -->
@if (showModal) {
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <span class="close" (click)="toggleModal()">&times;</span>
      </div>
      <div class="release-notes">
        <pre [innerHTML]="commitMessagesHtml"></pre>
      </div>
    </div>
  </div>
}
